import clsx from 'clsx';

import type { VaniaLoadingSystemProps } from './loading.types';
import './loading.css';

export function VaniaLoadingSystem({
  mode = 'bootstrap',
  label = 'در حال آماده‌سازی VaniaLabs',
  className,
  children,
}: VaniaLoadingSystemProps) {
  return (
    <div
      className={clsx('vania-loading-system', `vania-loading-system--${mode}`, className)}
      role="status"
      aria-label={typeof label === 'string' ? label : undefined}
      aria-busy="true"
    >
      {children ?? (
        <>
          <div className="vania-loading-system__mark" aria-hidden="true">V</div>
          <div className="vania-loading-system__content">
            <span className="vania-loading-system__brand">VaniaLabs</span>
            <span className="vania-loading-system__label">{label}</span>
            <span className="vania-loading-system__progress" aria-hidden="true" />
          </div>
        </>
      )}
    </div>
  );
}
